import createOrUpdateHiddenField from './createOrUpdateHiddenField';

/**
 *
 * @param {jQuery Object} $form The form to modify with updated or new fields
 * @param {Object} data object where the keys represent the value of the name attribute
 * on a form field and the values represent the value to update the field with
 * @example
 * // <input name='example' value=''></input> // field will be created or updated
 * data: {
 * 	'example': 'exampleval'
 * }
 * // <input name='example' value='exampleval'></input> // created or updated field
 */
const createOrUpdateHiddenFields = (form, data) => {
	Object.entries(data).forEach(([attrVal, fieldVal]) => {
		createOrUpdateHiddenField(form, attrVal, fieldVal);
	});
};

export default createOrUpdateHiddenFields;
